/*
 * Copyright (C) 2016 Spanning Cloud Apps.  All rights reserved.
 */
import './selectOperation.tpl.html';

angular
  .module('gdprRequest.selectOperation', [
    'shared.radioButton',
    'services.gdprrequest',
    'services.error',
    'services.useragent',
    'shared.wizard'
  ])
  /**
   * Controller for the gdprRequest.selectOperation template.
   */
  .controller('GdprSelectOperationViewCtrl', [
    '$scope',
    '$state',
    '$rootScope',
    '$filter',
    '$window',
    'progressFactory',
    'ErrorService',
    'GdprOperationType',
    'GdprRequestService',
    'httpBulkRestore',
    'UserAgentFactory',
    'WizardService',
    'WizardButtonFactory',
    'VIEW_STATES',
    function (
      $scope,
      $state,
      $rootScope,
      $filter,
      $window,
      progressFactory,
      ErrorService,
      GdprOperationType,
      GdprRequestService,
      httpBulkRestore,
      UserAgentFactory,
      WizardService,
      WizardButtonFactory,
      VIEW_STATES
    ) {
      if (!$state.params.gdprRequestData) {
        throw new Error('gdprRequestData is required');
      }

      const i18n = $filter('i18n');

      // Create a custom wizard button to the wizard to handle Verify
      const verifyButton = WizardButtonFactory.generate();
      verifyButton.setTextKey('VERIFY');
      verifyButton.setTooltipKey('VERIFY');
      verifyButton.setClick(runGdprVerification);
      verifyButton.setEnabled(isVerifyButtonValid);

      // Register our page with the wizard service
      const page = WizardService.getCurrentPage();
      page.setHeaderText(i18n('SELECT_OPERATION'));
      page.setCustomButtons(() => [verifyButton]);
      page.setStateParams($state.params);
      page.setTouched(function () {
        return $scope.touched;
      });
      page.setValid(isValid);

      $scope.gdprRequestData = $state.params.gdprRequestData;
      $scope.GdprOperationType = GdprOperationType;
      $scope.inTheFollowingOverwritingSteps = i18n('IN_FOLLOWING_STEPS_OVERWRITING_GDPR_REQUEST');
      $scope.inTheFollowingDeletionSteps = i18n('IN_FOLLOWING_STEPS_DELETION_GDPR_REQUEST');
      $scope.inTheFollowingAttentionSteps = i18n('IN_FOLLOWING_STEPS_ATTENTION_GDPR_REQUEST');

      let model;

      // Store data in a model object rather than the scope itself for easier watching
      $scope.model = model = {
        hasUploadFile: true,
        // For the purposes of confirming cancellation of the wizard we'll consider the wizard touched if we get this
        // far.
        touched: true,
        uploadBatchId: undefined,
        uploadFile: $scope.gdprRequestData.getUploadFile(),
        uploadSupported: !UserAgentFactory.isIE9()
      };

      /**
       * Utility method to check if current gdpr operation is override
       */
      $scope.isOverwriteOperation = function () {
        const currentOperation = $scope.gdprRequestData.getOperationType();

        return currentOperation === GdprOperationType.OVERWRITE;
      };

      /**
       * Utility method to check if current gdpr operation is delete
       */
      $scope.isDeleteOperation = function () {
        const currentOperation = $scope.gdprRequestData.getOperationType();

        return currentOperation === GdprOperationType.DELETE;
      };

      /**
       * Utility method to update gdpr operation type
       */
      $scope.setOperation = function (operation) {
        $scope.gdprRequestData.setOperationType(operation);
      };

      $scope.setOperation(GdprOperationType.OVERWRITE);

      /**
       * Determines whether the settings on the page are valid (i.e. Next is allowed in the wizard)
       *
       * @returns {boolean} true if the settings are valid, false otherwise.
       */
      function isValid() {
        if (!$scope.gdprRequestData.getOperationType()) {
          return false;
        }
        return true;
      }

      /**
       * Determines whether the verify button on the page is valid
       *
       * @returns {boolean} true if the button is valid, false otherwise.
       */
      function isVerifyButtonValid() {
        return !$rootScope.gdprOperationInProgress;
      }

      /**
       * Start server gdpr verification process and go to activity history page
       */
      function runGdprVerification() {
        return uploadFileAndQueueMessage().then((result) => {
          $state.go(VIEW_STATES.ACCOUNT);
          return result;
        });
      }

      /**
       * Function to upload CSV file to s3 and queue message.
       *
       * @returns {Promise} a promise that is resolved with one of the following:
       *   1) true if the wizard can be dismissed
       *   2) false if the wizard should remain
       *   3) an object containing the parameters to pass to the wizard cancel function to display an error message.
       */
      function uploadFileAndQueueMessage() {
        $rootScope.showLoadingMask = true;

        // Do the upload and verification in two separate steps so we can display the proper error.
        let uploaded = false;
        const timestamp = new Date().getTime();

        return GdprRequestService.getPreSignedPostUrl(timestamp)
          .then((url) => httpBulkRestore.uploadFileToUrl(url, model.uploadFile))
          .then(() => {
            uploaded = true;
            return GdprRequestService.submitGdprVerification(
              $scope.gdprRequestData,
              timestamp,
              $scope.gdprRequestData.getOperationType()
            );
          })
          .then(() => {
            // When the verification starts successfully, switch to the dashboard mask
            $rootScope.showLoadingMask = false;

            progressFactory.gdprOperationInProgress = true;

            // Reset the touched flag so the user can exit to the dashboard without another confirmation
            page.setTouched(false);
            model.touched = false;

            return true; // Close the wizard since we're allowing the user to quit from here.
          })
          .catch((err) => {
            $rootScope.showLoadingMask = false;

            // We're back to needing confirmation to exit
            model.touched = true;

            ErrorService.report(err, uploaded ? i18n('ERROR_OCCURRED') : i18n('UPLOAD_FILE_ERROR'));

            return false; // Stay in the wizard since something went wrong
          });
      }
    }
  ]);
